<template>
  <div class="m-b-sm has-background-primary">
    <div class="has-text-left">
      <router-link :to="{ name: 'Home' }">
        <img src="@/../static/gamega.me/logo_black.png" class="is-inline-block p-md" style="height:6rem;" />
      </router-link>
    </div>
    <span class="m-t-md m-r-md menu-icon" @click="showMenu">
      <img src="@/../static/gamega.me/menu_black.svg" class="is-inline-block is-large icon">
    </span>
    <Menu ref="menu" :show="false" />
  </div>
</template>

<script>
import Menu from '@/components/LangGG/Menu'

export default {
  name: 'Terms',
  methods: {
    showMenu () {
      this.$refs.menu.showMe()
    }
  },
  components: {
    Menu
  }
}
</script>

<style>
.menu-icon {
  position:absolute;
  top:1rem;
  right:0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/LangGG/Header.vue